import { useEffect } from 'react';

const WebmailRedirect = () => {
  useEffect(() => {
    window.location.replace('https://webmail.hostverge.com/');
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-600 font-medium">Redirecting to Webmail...</p>
      </div>
    </div>
  );
};

export default WebmailRedirect;